import PropTypes from 'prop-types';
import React from 'react';
import { faCheck, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function CheckBoxIcon({
  value,
  color = 'green',
  falseColor='green',
}: {
  value: boolean,
  color?: 'green' | 'red' | 'black',
  falseColor?: 'green' | 'red' | 'black',
}) {
  const chechboxIconStyle = {color: '#0d7757'};
  const chechboxIconStyle2 = {color: '#0d7757'};

  if (color === 'red') {
    chechboxIconStyle.color = '#DC2626';
  } else if (color === 'black') {
    chechboxIconStyle.color = '#000000';
  }

  if (falseColor === 'red') {
    chechboxIconStyle2.color = '#DC2626';
  } else if (falseColor === 'black') {
    chechboxIconStyle2.color = '#000000';
  }

  if (value) {
    return <span className="ifms-check-box-icon-true" style={chechboxIconStyle}><FontAwesomeIcon icon={faCheck} /></span>;
  } else {
    return <span className="ifms-check-box-icon-false" style={chechboxIconStyle2}><FontAwesomeIcon icon={faMinus} /></span>;
  }
}

CheckBoxIcon.defaultProps = {
  value: false,
  color: 'green',
  falseColor:'green'
};

CheckBoxIcon.propTypes = {
  value: PropTypes.bool.isRequired,
  color: PropTypes.oneOf(['green', 'red', 'black']),
  falseColor: PropTypes.oneOf(['green', 'red', 'black']),
};


export default React.memo(CheckBoxIcon);
